export const USER_ACTION_TYPES ={
    SET_CURRENT_USER: "SET_CURRENT_USER",
}

